import { NavLink } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
} from '@/components/ui/sidebar';
import { 
  LayoutDashboard, 
  Package, 
  Users, 
  TrendingUp, 
  Settings,
  Activity,
  Tag
} from 'lucide-react';
import { ADMIN_ROUTES } from '@/lib/admin-routes';

const menuItems = [
  { title: 'Dashboard', url: ADMIN_ROUTES.BASE, icon: LayoutDashboard, end: true },
  { title: 'Track Progress', url: ADMIN_ROUTES.BOOKINGS, icon: TrendingUp },
  { title: 'Services', url: ADMIN_ROUTES.SERVICES, icon: Package },
  { title: 'Contractors', url: ADMIN_ROUTES.CONTRACTORS, icon: Users },
  { title: 'Promo Codes', url: ADMIN_ROUTES.PROMO_CODES, icon: Tag },
  { title: 'Service Status', url: ADMIN_ROUTES.STATUS, icon: Activity },
  { title: 'Settings', url: ADMIN_ROUTES.SETTINGS, icon: Settings },
];

export function AppSidebar() {
  return (
    <Sidebar>
      <SidebarHeader className="border-b p-4">
        <div className="flex items-center gap-2">
          <img src="/logo.svg" alt="Logo" className="h-8 w-8" />
          <div>
            <p className="text-sm font-semibold">104 Admin</p>
            <p className="text-xs text-muted-foreground">Management Panel</p>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map(item => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink 
                      to={item.url} 
                      end={item.end}
                      className={({ isActive }) => 
                        isActive ? 'bg-accent text-accent-foreground' : ''
                      }
                    >
                      <item.icon className="h-4 w-4" />
                      <span>{item.title}</span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
